import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NoCellIcon(props: IconProps) {
    return <Icon {...props} iconKey={"no_cell"}/>
}
